import { makeRouter } from '@adornis/router/client/make-router.js';
import { html } from 'lit';
import { SGEmploymentPermitDetails } from './details/sg-employment-permit-details.js';
import { SGEmploymentPermitList } from './list/sg-employment-permit-list.js';

export const employmentPermitListRouter = makeRouter({
  details: {
    path: '/:permitID',
    documentTitlePart: '',
    render: params => html`
      <div class="flex flex-col md:flex-row">
        ${SGEmploymentPermitList({ userID: params.personID, activePermitID: params.permitID })}
        ${SGEmploymentPermitDetails({ permitID: params.permitID })}
      </div>
    `,
  },

  root: {
    path: '/',
    render: params => SGEmploymentPermitList({ userID: params.personID, activePermitID: null }),
    documentTitlePart: '',
  },
});
